<script>
    import { onMount } from 'svelte';

    // Utils
    import { getBorderRadius } from '$lib/global/helper/border-radius';

    export let open = false;
    export let disabled = false;
    export let handleClear;
    export let handleConfirm;
    export let setConfirmButtonRef;
    export let setClearButtonRef;
    export let btnClearLabel = '',
        btnConfirmLabel = '';

    let confirmRef;
    let clearRef;

    onMount(() => {
        setConfirmButtonRef(confirmRef);
        setClearButtonRef(clearRef);
    });

    let clearButtonClasses;
    let confirmButtonClasses;

    const borderRadius = getBorderRadius('button');

    $: buttonClasses = `${borderRadius} focus:before:${borderRadius} relative flex-1 h-12 outline-none transition duration-150 font-medium text-sm focus:before:content-[""] focus:before:absolute focus:before:-top-0.5 focus:before:-right-0.5 focus:before:-left-0.5 focus:before:-bottom-0.5 focus:before:border focus:before:border-blue-600 disabled:opacity-70`;
    $: clearButtonClasses = `${buttonClasses} text-gray-500 bg-gray-100 hover:text-gray-600 hover:bg-gray-200 disabled:hover:bg-gray-100 disabled:hover:text-gray-500`;
    $: confirmButtonClasses = `${buttonClasses} bg-blue-500 text-white hover:bg-blue-600 disabled:hover:bg-blue-500`;
</script>

<div class="flex gap-2 p-4 pt-0">
    <button
        {disabled}
        class={clearButtonClasses}
        bind:this={clearRef}
        on:click={handleClear}
        tabindex={open ? '0' : '-1'}>{btnClearLabel}</button
    >
    <button
        {disabled}
        class={confirmButtonClasses}
        bind:this={confirmRef}
        on:keydown={(event) => {
            event.key === 'Tab' && !event.shiftKey && event.preventDefault();
        }}
        on:click={handleConfirm}
        tabindex={open ? '0' : '-1'}>{btnConfirmLabel}</button
    >
</div>
